var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    fillRule: "evenodd",
    d: "M.844.688c.093-.094.218-.141.375-.141.156 0 .281.047.375.14l9.937 9.938c.094.094.14.219.14.375s-.046.281-.14.375l-9.937 9.937c-.094.094-.219.141-.375.141-.157 0-.282-.047-.375-.14l-.375-.376c-.094-.093-.14-.218-.14-.375 0-.156.046-.296.14-.421L9.656 11 .47 1.86c-.094-.126-.14-.266-.14-.422 0-.157.046-.282.14-.375L.844.688z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevron);
export default __webpack_public_path__ + "static/media/right-chevron.b4d1a1270d492747276800712e779ae6.svg";
export { ForwardRef as ReactComponent };